import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getWoundCareSelector } from '../selectors'
import { WoundCareConstants } from '../store/woundCare.constants'
import { IWoundCareState } from '../store/woundCare.types'

export function* setProcedureComplications() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const woundCareState: IWoundCareState = yield select(getWoundCareSelector)
  const { inputRows } = procedureState
  const { procedureComplications } = woundCareState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === WoundCareConstants.SET_PROCEDURE_COMPLICATIONS) {
        //@ts-ignore
        input.props.savedValues = procedureComplications
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setProcedureComplicationsSaga() {
  yield takeLatest([WoundCareConstants.SET_PROCEDURE_COMPLICATIONS], setProcedureComplications)
}
